// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero-height[data-v-3cccf1bf]{min-height:100vh}@media (min-width:1280px){.hero-height[data-v-3cccf1bf]{min-height:calc(100vh - 7.6875rem)}}.scroll-icon[data-v-3cccf1bf]{left:50%;transform:translatex(-50%)}.image-gradient[data-v-3cccf1bf]{background:linear-gradient(95deg,rgba(13,33,38,.6),rgba(13,33,38,0) 75%)}.product-link[data-v-3cccf1bf]{top:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
